"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultFilterOperation(type) {
    if (type === "string" || type === "stringLink" || type === "stringSelect" || type === "stringLong") {
        return "~";
    }
    return ">";
}
var ColumnInfo = /** @class */ (function () {
    function ColumnInfo(label, fieldName, type, operation, postFix, decimalCount, filterOperation) {
        if (postFix === void 0) { postFix = ""; }
        if (decimalCount === void 0) { decimalCount = 0; }
        this.label = label;
        this.fieldName = fieldName;
        this.type = type;
        this.operation = operation;
        this.postFix = postFix;
        this.decimalCount = decimalCount;
        this.filterOperation = filterOperation;
        if (!this.filterOperation && this.filterOperation != "") {
            this.filterOperation = getDefaultFilterOperation(this.type);
        }
    }
    return ColumnInfo;
}());
exports.ColumnInfo = ColumnInfo;
//# sourceMappingURL=ColumnInfo.js.map